/**
 * Documentation Geoprod
 * Description des web services de Remoteprod
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
  HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ModelObject } from '../model/modelObject';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {environment} from "../../../environments/environment";


@Injectable()
export class ApiQualificateurService {

  protected basePath = environment.api_url;
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * afficher l’agenda des qualificateur pendant les 18 dernier mois
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAgendaQualifGet(observe?: 'body', reportProgress?: boolean): Observable<any>;
  public getAgendaQualifGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public getAgendaQualifGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public getAgendaQualifGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let headers = this.defaultHeaders;

    // authentication (Acess_Token) required
    if (this.configuration.apiKeys && this.configuration.apiKeys["idSession"]) {
      headers = headers.set('idSession', this.configuration.apiKeys["idSession"]);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<any>('get',`${this.basePath}/get_agenda_qualif`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Afficher les collaboratuers affecté au qualificateurs
   *
   * @param idQualif identifiant de qualificateur codé en md5
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCollabWithQualifGet(idQualif: ModelObject, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public getCollabWithQualifGet(idQualif: ModelObject, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public getCollabWithQualifGet(idQualif: ModelObject, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public getCollabWithQualifGet(idQualif: ModelObject, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    if (idQualif === null || idQualif === undefined) {
      throw new Error('Required parameter idQualif was null or undefined when calling getCollabWithQualifGet.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (idQualif !== undefined && idQualif !== null) {
      queryParameters = queryParameters.set('id_qualif', <any>idQualif);
    }

    let headers = this.defaultHeaders;

    // authentication (Acess_Token) required
    if (this.configuration.apiKeys && this.configuration.apiKeys["idSession"]) {
      headers = headers.set('idSession', this.configuration.apiKeys["idSession"]);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<any>('get',`${this.basePath}/get_collab_with_qualif`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *  afficher la liste des qualificateur actif
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getQualifGet(observe?: 'body', reportProgress?: boolean): Observable<any>;
  public getQualifGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public getQualifGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public getQualifGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let headers = this.defaultHeaders;

    // authentication (Acess_Token) required
    if (this.configuration.apiKeys && this.configuration.apiKeys["idSession"]) {
      headers = headers.set('idSession', this.configuration.apiKeys["idSession"]);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<any>('get',`${this.basePath}/get_qualif`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Afficher les collaboratuers affecté au qualificateurs
   *
   * @param idCollab identifiant de collaborateur codé en md5
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getQualifWithCollabGet(idCollab: ModelObject, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public getQualifWithCollabGet(idCollab: ModelObject, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public getQualifWithCollabGet(idCollab: ModelObject, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public getQualifWithCollabGet(idCollab: ModelObject, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    if (idCollab === null || idCollab === undefined) {
      throw new Error('Required parameter idCollab was null or undefined when calling getQualifWithCollabGet.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (idCollab !== undefined && idCollab !== null) {
      queryParameters = queryParameters.set('id_collab', <any>idCollab);
    }

    let headers = this.defaultHeaders;

    // authentication (Acess_Token) required
    if (this.configuration.apiKeys && this.configuration.apiKeys["idSession"]) {
      headers = headers.set('idSession', this.configuration.apiKeys["idSession"]);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<any>('get',`${this.basePath}/get_qualif_with_collab`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Affiche le tableau de bord journalier des qualifcateurs
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRdvQualifGet(observe?: 'body', reportProgress?: boolean): Observable<any>;
  public getRdvQualifGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public getRdvQualifGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public getRdvQualifGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let headers = this.defaultHeaders;

    // authentication (Acess_Token) required
    if (this.configuration.apiKeys && this.configuration.apiKeys["idSession"]) {
      headers = headers.set('idSession', this.configuration.apiKeys["idSession"]);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<any>('get',`${this.basePath}/get_rdv_qualif`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * modifier l’affectation d’un qualificateur a un collaborateur
   *
   * @param idCollab Identifiant de collaborateur codé en md5
   * @param idQualif Identifiant de qualificateur codé en md5 ou -1
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateQualifCollabAffGet(idCollab: ModelObject, idQualif: ModelObject, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public updateQualifCollabAffGet(idCollab: ModelObject, idQualif: ModelObject, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public updateQualifCollabAffGet(idCollab: ModelObject, idQualif: ModelObject, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public updateQualifCollabAffGet(idCollab: ModelObject, idQualif: ModelObject, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    if (idCollab === null || idCollab === undefined) {
      throw new Error('Required parameter idCollab was null or undefined when calling updateQualifCollabAffGet.');
    }

    if (idQualif === null || idQualif === undefined) {
      throw new Error('Required parameter idQualif was null or undefined when calling updateQualifCollabAffGet.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (idCollab !== undefined && idCollab !== null) {
      queryParameters = queryParameters.set('id_collab', <any>idCollab);
    }
    if (idQualif !== undefined && idQualif !== null) {
      queryParameters = queryParameters.set('id_qualif', <any>idQualif);
    }

    let headers = this.defaultHeaders;

    // authentication (Acess_Token) required
    if (this.configuration.apiKeys && this.configuration.apiKeys["idSession"]) {
      headers = headers.set('idSession', this.configuration.apiKeys["idSession"]);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<any>('get',`${this.basePath}/update_qualif_collab_aff`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
